module.exports = "mutation CommitPurchase($purchaseIntentId: String!) {\n  commitPurchase(purchaseIntentId: $purchaseIntentId) {\n    paid\n  }\n}\n"